module.exports = __webpack_public_path__ + "img/report-9.2fb88614.jpg";